import { makeStyles } from '@material-ui/core/styles'
import PropTypes from 'prop-types'
import React from 'react'
import Typography from '@material-ui/core/Typography'
import { LayoutProvider } from './LayoutContext'
import Hidden from '@material-ui/core/Hidden'

import Breadcrumbs from './breadcrumbs'
import SideDrawer from './Drawer'
import AppBar from './AppBar'

const useStyles = makeStyles((theme) => ({
  root: { display: 'flex' },
  container: { padding: theme.spacing(2) },
  content: {
    flexGrow: 1,
    minHeight: '100vh',
    backgroundColor: '#F2F2F2',
    padding: '48px 24px 0',
    overflow: 'auto',
  },
  title: { marginBottom: theme.spacing(3) },
}))

function Index({ title, children, breadcrumbs: { previous, current } }) {
  const classes = useStyles()
  return (
    <LayoutProvider>
      <Hidden mdUp implementation="css">
        <AppBar />
      </Hidden>
      <div className={classes.root}>
        <Hidden smDown implementation="css">
          <SideDrawer />
        </Hidden>
        <main className={classes.content}>
          {/* Breadcrumbs */}
          <Breadcrumbs current={current} previous={previous} />
          {/* Title */}
          <Typography variant="h5" className={classes.title}>
            {title}
          </Typography>
          {children}
        </main>
      </div>
    </LayoutProvider>
  )
}

Index.defaultProps = {
  breadcrumbs: { previous: [], current: '' },
}

Index.propTypes = {
  children: PropTypes.node,
  title: PropTypes.string,
  breadcrumbs: PropTypes.shape({
    previous: PropTypes.arrayOf(
      PropTypes.shape({
        href: PropTypes.string.isRequired,
        name: PropTypes.string.isRequired,
      })
    ),
    current: PropTypes.string.isRequired,
  }),
}

export default Index
